/**
 * F-827: one scale for SpO2 on the way to the server.
 *
 * HealthKit hands the app oxygen saturation as a fraction (0.96); Health Connect hands it as a
 * percent (96). blaze stores `numeric_value` as sent and every reader (blaze, the kernel) treats a
 * stored SpO2 as a fraction and multiplies it by 100, so a Health Connect reading was shown as
 * 9600 %. The app now always uploads a fraction.
 *
 * Guard: a value above 1 is a percent (no real fraction exceeds 1, and no real percent is 1 or
 * below), so values in (1, 100] are divided by 100. Anything else (a fraction, a negative, a value
 * above 100) is sent unchanged; readers already skip impossible SpO2.
 */

export const SPO2_ACTIVITY_TYPE = "oxygensaturation";

export function spo2AsFraction(value: number): number {
  if (!Number.isFinite(value)) return value;
  if (value > 1 && value <= 100) {
    // Round to 4 places so 97 -> 0.97 and 96.5 -> 0.965 without float noise (0.9650000000000001).
    return Math.round(value * 100) / 10000;
  }
  return value;
}

/** The numeric value to upload for a health record of `activityType`. */
export function normaliseUploadValue(activityType: string, value: number): number {
  return activityType === SPO2_ACTIVITY_TYPE ? spo2AsFraction(value) : value;
}
